export default __webpack_public_path__ + "static/media/european_union.a7199ae6.svg";